import { useOptionalDependency } from 'ditox-react';
import { useSubscription } from 'observable-hooks';
import { useState } from 'react';
import { EMPTY } from 'rxjs';
import { COMM_MANAGER_TOKEN } from '@/container';
import type { HeaderActionData } from '@/models/events/comm-event';
import { SafeImage } from './safe-image';

const HeaderActionButton = () => {
  const commManager = useOptionalDependency(COMM_MANAGER_TOKEN);
  const [headerAction, setHeaderAction] = useState<HeaderActionData | undefined>(undefined);

  useSubscription(commManager?.event$ ?? EMPTY, (event) => {
    switch (event.event) {
      case 'header-action':
        setHeaderAction(event.data);
        break;
      case 'clear-header-action':
        if (headerAction?.key === event.data.key) {
          setHeaderAction(undefined);
        }
        break;
    }
  });

  if (!headerAction) return null;

  return (
    <button
      type='button'
      style={headerAction.style}
      className='btn border-none btn-xs hover:opacity-70'
      onClick={(e) => {
        e.preventDefault();
        commManager?.dispatch({
          event: 'trigger-action',
          data: {
            key: headerAction.key,
            action: 'header-action',
          },
        });
      }}>
      <span className='flex items-center gap-1'>
        <SafeImage
          displayType='img'
          alt='live_indicator'
          src={headerAction.icon}
          className='aspect-square size-4 bg-transparent'
        />
        {headerAction.label}
      </span>
    </button>
  );
};

export default HeaderActionButton;
